import { render, staticRenderFns } from "./cardItemByCourse.vue?vue&type=template&id=61a4e2d8&"
import script from "./cardItemByCourse.vue?vue&type=script&lang=js&"
export * from "./cardItemByCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/card/cardItemByCourse.vue"
export default component.exports